import { render, staticRenderFns } from "./StartseiteFinanzen.vue?vue&type=template&id=3193f81a&"
import script from "./StartseiteFinanzen.vue?vue&type=script&lang=js&"
export * from "./StartseiteFinanzen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports